import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/molbio_analytics.py
export const MOLBIO_ANALYTICS_ACTIONS = {
  OPENED_CODON_OPTIMIZATION: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'opened_codon_optimiation',
    actionCategory: ACTION_CATEGORY.READ,
  },
  PERFORMED_CODON_OPTIMIZATION: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'performed_codon_optimization',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SAVED_CODON_OPTIMIZED_SEQUENCE: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'saved_codon_optimized_sequence',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_CODON_OPTIMIZED_SEQUENCE: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'created_codon_optimized_sequence',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPENED_BULK_ASSEMBLY: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'opened_bulk_assembly',
    actionCategory: ACTION_CATEGORY.READ,
  },
  DOWNLOADED_FORMATTED_ALIGNMENT_PDF: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'downloaded_formatted_alignment_pdf',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_FORMATTED_PDF_MODAL: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'opened_formatted_pdf_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RETRIED_HOMOLOGY_DETECTION: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'retried_homology_detection',
    actionCategory: ACTION_CATEGORY.READ,
  },
  USED_ALIGNMENT_MISMATCH_NAVIGATION: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'used_alignment_mismatch_navigation',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_BIOCHEMICAL_PROPERTIES_TAB_ON_DNA: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'opened_biochemical_properties_tab_on_dna',
    actionCategory: ACTION_CATEGORY.READ,
  },
  VIEWED_SEQUENCE_ENTITY_MAP_TAB: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'viewed_sequence_entity_map_tab',
    actionCategory: ACTION_CATEGORY.READ,
  },
  VIEWED_SEQUENCE_ENTITY_DESCRIPTION_TAB: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'viewed_sequence_entity_description_tab',
    actionCategory: ACTION_CATEGORY.READ,
  },
  VIEWED_SEQUENCE_ENTITY_METADATA_TAB: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'viewed_sequence_entity_metadata_tab',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_SEQUENCE_ENTITY_SEQUENCE_MAP: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'clicked_sequence_entity_map',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_RIGHT_ON_SELECTED_SEQUENCE_BASES: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'clicked_right_on_selected_sequence_bases',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_CREATE_IN_SEQUENCE_MAP: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'clicked_create_in_sequence_map',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_ANALYZE_IN_SEQUENCE_MAP: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'clicked_analyze_in_sequence_map',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_ANNOTATION_IN_SEQUENCE_MAP: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'clicked_annotation_in_sequence_map',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_SEQUENCE_MAP_SEARCH_MODAL: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'opened_sequence_map_search_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SELECTED_BASES_IN_MAP: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'selected_bases_in_map',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_CREATE_OLIGO_MODAL: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'opened_create_oligo_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  UPLOADED_NUCLEOTIDE_IMPORT_SPREADSHEET: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'uploaded_nucleotide_import_spreadsheet',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ENTERED_VALUE_IN_NUCLEOTIDE_CREATE_MODAL: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'entered_value_in_nucleotide_create_modal',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SUBMITTED_NUCLEOTIDE_CREATE_MODAL: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'submitted_nucleotide_create_modal',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  COPIED_ALIGNMENT_URL: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'copied_alignment_url',
    actionCategory: ACTION_CATEGORY.READ,
  },
  LOADED_ALIGNMENT_URL: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'loaded_alignment_url',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_BULK_BACK_TRANSLATION: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'opened_bulk_back_translation',
    actionCategory: ACTION_CATEGORY.READ,
  },
  PERFORMED_BULK_BACK_TRANSLATION: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'performed_bulk_back_translation',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_BULK_CODON_OPTIMIZATION: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'opened_bulk_codon_optimization',
    actionCategory: ACTION_CATEGORY.READ,
  },
  PERFORMED_BULK_CODON_OPTIMIZATION: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'performed_bulk_codon_optimization',
    actionCategory: ACTION_CATEGORY.READ,
  },
  UPLOADED_MOLFILE: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'uploaded_molfile',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPENED_RNA_SEQUENCE_FROM_TRANSCRIPTION_VISUALIZATION: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'opened_rna_sequence_from_transcription_visualization',
    actionCategory: ACTION_CATEGORY.READ,
  },
  // Redesigned buk assembly flow
  VIEWED_BULK_ASSEMBLY_BETA_BANNER: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'viewed_bulk_assembly_beta_banner',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_REDESIGNED_BULK_ASSEMBLY_LINK: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'clicked_redesigned_bulk_assembly_link',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLOSED_REDESIGNED_BULK_ASSEMBLY_MODAL: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'closed_redesigned_bulk_assembly_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  INITIATED_BULK_ASSEMBLY: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'initiated_bulk_assembly',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_BULK_ASSEMBLY_SETUP_MODAL: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'opened_bulk_assembly_setup_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  UPDATED_BULK_ASSEMBLY_NAME_FIELD: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'updated_bulk_assembly_name_field',
    // Note: this fires when the user changes the name field, not when the new name is submitted
    actionCategory: ACTION_CATEGORY.READ,
  },
  UPDATED_BULK_ASSEMBLY_CLONING_METHOD_FIELD: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'updated_bulk_assembly_cloning_method_field',
    // Note: this fires when the user changes the cloning method, not when the new method is submitted
    actionCategory: ACTION_CATEGORY.READ,
  },
  UPDATED_BULK_ASSEMBLY_TOPOLOGY: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'updated_bulk_assembly_topology_field',
    // Note: this fires when the user changes the topology, not when the new value is submitted
    actionCategory: ACTION_CATEGORY.READ,
  },
  UPDATED_BULK_ASSEMBLY_OUTPUT_SEQUENCE_TYPE: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'updated_bulk_assembly_output_sequence_type',
    actionCategory: ACTION_CATEGORY.READ,
  },
  UPDATED_BULK_ASSEMBLY_NUCLEOTIDE_TYPE: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'updated_bulk_assembly_nucleotide_type_field',
    // Note: this fires when the user changes the topology, not when the new value is submitted
    actionCategory: ACTION_CATEGORY.READ,
  },
  UPDATED_BULK_ASSEMBLY_PRIMER_PARAMETERS: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'updated_bulk_assembly_primer_parameters',
    // Note: this fires when the user changes the primer parameters, not when the new parameters are submitted
    actionCategory: ACTION_CATEGORY.READ,
  },
  UPDATED_BULK_ASSEMBLY_ENZYME: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'updated_bulk_assembly_enzyme',
    // Note: this fires when the user changes the enzyme, not when the new enzyme is submitted
    actionCategory: ACTION_CATEGORY.READ,
  },
  UPDATED_BULK_ASSEMBLY_FRAGMENT_PRODUCTION_METHOD: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'updated_bulk_assembly_fragment_production_method',
    // Note: this fires when the user changes the fragment production method, not when the new method is saved
    actionCategory: ACTION_CATEGORY.READ,
  },
  SAVED_BULK_ASSEMBLY_SETTINGS: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'saved_bulk_assembly_settings',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ADDED_BULK_ASSEMBLY_BIN: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'added_bulk_assembly_bin',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_BULK_ASSEMBLY_BIN_NAME: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'updated_bulk_assembly_bin_name',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_BULK_ASSEMBLY_BIN_NUMBER: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'updated_bulk_assembly_bin_number',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_BULK_ASSEMBLY_BIN_SETTINGS: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'updated_bulk_assembly_bin_settings',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DELETED_BULK_ASSEMBLY_BIN: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'deleted_bulk_assembly_bin',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ADDED_BULK_ASSEMBLY_SPACER: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'added_bulk_assembly_spacer',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_BULK_ASSEMBLY_SPACER_NUMBER: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'updated_bulk_assembly_spacer_number',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_BULK_ASSEMBLY_SPACER_SETTINGS: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'updated_bulk_assembly_spacer_settings',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DELETED_BULK_ASSEMBLY_SPACER: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'deleted_bulk_assembly_spacer',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPENED_BULK_ASSEMBLY_ADD_FRAGMENTS_MODAL: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'opened_bulk_assembly_add_fragments_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  UPDATED_BULK_ASSEMBLY_PREFERRED_PRIMER: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'updated_bulk_assembly_fragment_preferred_primer',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_BULK_ASSEMBLY_FRAGMENT_SWAP_ENDPOINTS_BUTTON: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'clicked_bulk_assembly_fragment_swap_endpoints_button',
    actionCategory: ACTION_CATEGORY.READ,
  },
  UPDATED_BULK_ASSEMBLY_FRAGMENT_MODAL_ACTIVE_FRAGMENT: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'updated_bulk_assembly_fragment_modal_active_fragment',
    actionCategory: ACTION_CATEGORY.READ,
  },
  ADDED_BULK_ASSEMBLY_FRAGMENTS: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'added_bulk_assembly_fragments',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPENED_BULK_ASSEMBLY_EDIT_FRAGMENT_MODAL: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'opened_bulk_assembly_edit_fragment_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  UPDATED_BULK_ASSEMBLY_FRAGMENT: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'updated_bulk_assembly_fragment',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_BULK_ASSEMBLY_FRAGMENTS_TABLE: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'updated_bulk_assembly_fragments_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_BULK_ASSEMBLY_CONSTRUCTS_TABLE: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'updated_bulk_assembly_constructs_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DELETED_BULK_ASSEMBLY_CONSTRUCT: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'deleted_bulk_assembly_construct',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  EDITED_BULK_ASSEMBLY_CONSTRUCT_IN_TABLE: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'edited_bulk_assembly_construct_in_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_BULK_ASSEMBLY_AUTOPOPULATE_BUTTON: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'clicked_bulk_assembly_autopopulate_button',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_BULK_ASSEMBLY_CLEAR_CONSTRUCTS_BUTTON: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'clicked_bulk_assembly_clear_constructs_button',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPENED_BULK_ASSEMBLY_CONSTRUCT_PREVIEW_MODAL: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'opened_bulk_assembly_construct_preview_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  UPDATED_BULK_ASSEMBLY_CONSTRUCT_MODAL_ACTIVE_TAB: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'updated_bulk_assembly_construct_modal_active_tab',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_BULK_ASSEMBLY_FINALIZATION_MODAL: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'opened_bulk_assembly_finalization_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SUBMITTED_BULK_ASSEMBLY_FINALIZATION_MODAL: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'submitted_bulk_assembly_finalization_modal',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  COMPLETED_BULK_ASSEMBLY_FINALIZATION: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'completed_bulk_assembly_finalization',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_ALPHAFOLD_PROVIDE_FEEDBACK: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'alphafold_click_provide_feedback',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_ALPHAFOLD_REDO_RUN: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'alphafold_click_redo_run',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_ALPHAFOLD_CONFIRM_REDO_RUN: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'alphafold_confirm_redo_run',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DOWNLOADED_ALPHAFOLD_STRUCTURE: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'alphafold_download_structure',
    actionCategory: ACTION_CATEGORY.READ,
  },
  REQUESTED_ALPHAFOLD_RUN: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'alphafold_request_run',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  INTERACTED_ALPHAFOLD_VIEWER: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'alphafold_viewer_interaction',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SIGNUP_ALPHAFOLD_WAITLIST: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'alphafold_sign_up_for_waitlist',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  // Visual Sequence History (and Assembly History)
  VIEWED_VISUAL_HISTORY_TAB: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'viewed_visual_history_tab',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_VISUAL_HISTORY_TAB: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'clicked_visual_history_tab',
    actionCategory: ACTION_CATEGORY.READ,
  },
  VIEWED_ASSEMBLY_HISTORY_TAB: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'viewed_assembly_history_tab',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_ASSEMBLY_HISTORY_TAB: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'clicked_assembly_history_tab',
    actionCategory: ACTION_CATEGORY.READ,
  },
  UPDATED_BULK_ASSEMBLY_VALIDATION: {
    module: ANALYTICS_MODULE.MOLBIO,
    action: 'updated_bulk_assembly_validation',
    actionCategory: ACTION_CATEGORY.READ,
  },
};
